import React from 'react';
import { ReleaseArtwork } from './ReleaseArtwork';
import type { ReleaseSchema } from '../../../types/schema';
import { Link } from '../atoms/Link';
import { style, classes } from 'typestyle';
import { Album } from '../atoms/icons/Album';
import { center, flexRoot } from 'csstips';
import { fontstackDefault } from '../config';
import { px } from 'csx';
import { rebrand } from '../../../theme/color';

interface ReleaseTileProps {
  release: ReleaseSchema;
  className?: string;
}

const styles = {
  wrapper: style({
    position: 'relative',
    width: '100%',
  }),
  artworkLink: style({
    display: 'block',
  }),
  releaseHeading: style(flexRoot, {
    fontFamily: fontstackDefault,
    fontWeight: 700,
    fontSize: px(16),
    lineHeight: 1.25,
    margin: '8px 0 2px',
    $nest: {
      '& a': {
        color: rebrand.contrast[50].toString(),
      },
      '& a:hover': {
        textDecoration: 'underline',
      },
    },
  }),
  releaseIcon: style({
    marginRight: px(6),
    flexShrink: 0,
  }),
  artist: style({
    margin: 0,
    color: rebrand.neutralOnLight[70].toString(),
    $nest: {
      '& a': {
        color: rebrand.neutralOnLight[70].toString(),
      },
      '& a:hover': {
        textDecoration: 'underline',
      },
    },
  }),
};

export const ReleaseTile: React.FC<ReleaseTileProps> = ({ release, className }) => {
  const releaseHref = `/music/artists/${release.artist.slug}/release/${release.slug}`;
  const artistHref = `/music/artists/${release.artist.slug}`;

  return (
    <div className={classes(styles.wrapper, className)}>
      <Link className={styles.artworkLink} href={releaseHref} aria-label={release.title}>
        <ReleaseArtwork release={release} small />
      </Link>
      <h4 className={styles.releaseHeading}>
        <Album size={20} className={styles.releaseIcon} />
        <Link href={releaseHref}>{release.title}</Link>
      </h4>
      <p className={styles.artist}>
        <Link href={artistHref}>{release.artist.name}</Link>
      </p>
    </div>
  );
};
